import { Component, ElementRef, forwardRef, Inject, NgZone, PLATFORM_ID, TransferState } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import {
  DxTemplateHost,
  DxTextBoxComponent,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { AbcTooltipDirective } from '../abc-tooltip.directive';
import { AbcCoreComponentService } from '../abcCoreComponent.service';

@Component({
  standalone: true,
  selector: 'abc-text-box',
  hostDirectives: [
    {
      directive: AbcTooltipDirective,
    },
  ],
  providers: [
    DxTemplateHost,
    WatcherHelper,
    IterableDifferHelper,
    NestedOptionHost,
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => AbcTextBoxComponent),
    },
  ],
  template: '',
})
export class AbcTextBoxComponent extends DxTextBoxComponent {
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any,
    private abcCoreComponentService: AbcCoreComponentService,
    private abcTooltipDirective: AbcTooltipDirective,
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, _idh, optionHost, transferState, platformId);
    this.abcTooltipDirective.elementClassName = '.dx-texteditor-input';
    this.init();
  }

  private init() {
    this.labelMode = this.labelMode ?? this.abcCoreComponentService.labelMode;
    this.stylingMode = this.stylingMode ? this.stylingMode : this.abcCoreComponentService.stylingMode;
  }
}
